import * as echarts from 'echarts';

interface ChartCaptureOptions {
  width?: number;
  height?: number;
  pixelRatio?: number;
}

const DEFAULT_OPTIONS: ChartCaptureOptions = {
  width: 900,
  height: 400,
  pixelRatio: 2,
};

/**
 * Renders an ECharts option off-screen and returns a base64 PNG data URL.
 * Creates a temporary hidden container, renders the chart, captures, and cleans up.
 */
export function captureChart(
  option: echarts.EChartsOption,
  opts?: ChartCaptureOptions
): string {
  const { width, height, pixelRatio } = { ...DEFAULT_OPTIONS, ...opts };

  const container = document.createElement('div');
  container.style.cssText = `position:absolute;left:-9999px;top:-9999px;width:${width}px;height:${height}px;`;
  document.body.appendChild(container);

  try {
    const chart = echarts.init(container, undefined, { width, height });
    chart.setOption({ ...option, animation: false }, true);
    const dataUrl = chart.getDataURL({
      type: 'png',
      pixelRatio,
      backgroundColor: '#ffffff',
    });
    chart.dispose();
    return dataUrl;
  } finally {
    document.body.removeChild(container);
  }
}
